export default "__VITE_ASSET__C7vVHUN6__"